import {
  SLACK_ACCOUNTS,
  SLACK_OAUTH_URL,
  SLACK_REVOKE,
  SLACK_CHANNELS,
  SLACK_SEND_TEST,
} from '@mm/api-routes';
import { SlackDataType } from '../model/CampaignsModel';
import AuthenticatedController from './AuthenticatedController';

export default class SlackController extends AuthenticatedController {
  static async getOauthUrl(redirectTo: string, facebookPageId: number) {
    return super.get(SLACK_OAUTH_URL, {
      redirect_to: redirectTo,
      facebook_page_id: facebookPageId,
    });
  }

  static async getAccounts(facebokPageId: number) {
    return super.get(SLACK_ACCOUNTS, {
      facebook_page_id: facebokPageId,
    });
  }

  static async getChannels(teamId: string) {
    return super.get(SLACK_CHANNELS, {
      team_id: teamId,
    });
  }

  static async revokeAccess(accountId: number) {
    return super.post(SLACK_REVOKE, {
      account_id: accountId,
    });
  }

  static async sendTest(params: SlackDataType) {
    return super.post(SLACK_SEND_TEST, params);
  }
}
